import React from "react";
import styled from "styled-components";

type FieldSyncBadgeKind = "backend" | "local" | "mock" | "partial" | "ia";

type FieldSyncBadgeProps = {
  kind: FieldSyncBadgeKind;
  label?: string;
};

const labels: Record<FieldSyncBadgeKind, string> = {
  backend: "Backend",
  local: "Local",
  mock: "Sem endpoint",
  partial: "Parcial",
  ia: "IA",
};

const ariaLabels: Record<FieldSyncBadgeKind, string> = {
  backend: "Campo sincronizado com backend",
  local: "Campo salvo somente neste navegador",
  mock: "Campo sem endpoint de backend",
  partial: "Campo com sincronizacao parcial",
  ia: "Campo preenchido por sugestao de IA",
};

const Badge = styled.span<{ $kind: FieldSyncBadgeKind }>`
  align-items: center;
  border-radius: 999px;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1;
  padding: 4px 8px;
  text-transform: none;

  ${({ $kind }) => {
    if ($kind === "backend") {
      return "background: #e6f4ea; color: #137333; border: 1px solid #a7f3d0;";
    }

    if ($kind === "mock") {
      return "background: #fef3c7; color: #92400e; border: 1px solid #fcd34d;";
    }

    if ($kind === "partial") {
      return "background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe;";
    }

    if ($kind === "ia") {
      return "background: #eef2ff; color: #4338ca; border: 1px solid #c7d2fe;";
    }

    return "background: #f1f5f9; color: #475569; border: 1px solid #cbd5e1;";
  }}
`;

export const FieldSyncBadge: React.FC<FieldSyncBadgeProps> = ({
  kind,
  label,
}) => (
  <Badge $kind={kind} aria-label={ariaLabels[kind]}>
    {label || labels[kind]}
  </Badge>
);
